module.exports = __webpack_public_path__ + "static/media/team_6.aecc8a49.jpg";